// Material Kit 2 React pages
import Achievements from "pages/Achievements";

export default function AchievementsPage() {
  return <Achievements />;
}
